import axios from 'axios'
import Vue from 'vue'

export default {
    state: {
        devices: [],
        selectedDevice: {},
        ticketHistory: null,
        ticketHistoryLoading: false,
        ticket: null,
        batteryHealth: null,
        batteryHealthLoading: false,
        types: null,
        searching: false,
    },
    getters: {
        devices: state => state.devices,
        devicesNames: state => state.devices.map(device => device.uniId),
        selectedDevice: state => state.selectedDevice,
        ticketHistory: state => state.ticketHistory,
        ticketHistoryLoading: state => state.ticketHistoryLoading,
        ticket: state => state.ticket,
        batteryHealth: state => state.batteryHealth,
        batteryHealthLoading: state => state.batteryHealthLoading,
        hasServicePermissions: state => serviceName => state.types !== null && state.types.filter((type) => type.name === serviceName).length > 0,
        types: state => state.types,
        searching: state => state.searching,
    },
    mutations: {
        setDevices(state, devices) {
            state.devices = devices
        },
        setSelectedDevice(state, device) {
            state.selectedDevice = device
        },
        setSearching(state, isSearching) {
            state.searching = isSearching
        },
        setTicketHistory(state, ticketHistory) {
            state.ticketHistory = ticketHistory
        },
        resetTicketHistory(state) {
            state.ticketHistory = null
        },
        setTicket(state, ticket) {
            state.ticket = ticket
        },
        resetTicket(state) {
            state.ticket = null
        },
        setBatteryHealth(state, batteryHealth) {
            state.batteryHealth = batteryHealth
        },
        resetBatteryHealth(state) {
            state.batteryHealth = null
        },
        setTypes(state, types) {
            state.types = types
        },
        resetTypes(state) {
            state.types = null
        },
    },
    actions: {
        async downloadDevices({commit, rootGetters}, search = '') {

            commit('setSearching', true)

            await axios.get(
                '/companies/' + rootGetters.companyId + '/devices' +
                '?assetNumber=' + search + '&extended='
            ).then(function (response){
                if (response.status === 200) {
                    commit('setDevices', response.data)
                }
            }).catch(error => {})

            commit('setSearching', false)
        },
        async downloadExtendedDevices({commit, rootGetters}, search = '') {
            const response = await axios.get(
                '/companies/' + rootGetters.companyId + '/devices' +
                '?assetNumber=' + search + '&extended=1'
            )
            if (response.status === 200 && response.data.length > 0) {
                commit('resetTicketHistory')
                commit('resetTicket')
                commit('resetBatteryHealth')
                commit('setSelectedDevice', response.data[0])
            }
        },
        async downloadDeviceBatteryHealth({state, commit, rootGetters}, assetId) {
            if (state.batteryHealth !== null) {
                return
            }
            state.batteryHealthLoading = true;
            await axios.get('/companies/' + rootGetters.companyId + '/devices/' + assetId + '/battery-health').then(function (response){
                if (response.status === 200) {
                    commit('setBatteryHealth', response.data)
                }
            }).catch(error => {})
            state.batteryHealthLoading = false;
        },
        async downloadDeviceTicketHistory({state, commit, rootGetters}, assetId) {
            if (state.ticketHistory !== null) {
                return
            }
            state.ticketHistoryLoading = true;
            await axios.get('/companies/' + rootGetters.companyId + '/devices/' + assetId + '/ticket-history').then(function (response) {
                if (response.status === 200) {
                    commit('setTicketHistory', response.data)
                }
            }).catch(error => {})
            state.ticketHistoryLoading = false;
        },
        async downloadTicket({state, commit, rootGetters}, {ticketId}) {
            commit('resetTicket')
            await axios.get('/companies/' + rootGetters.companyId + '/tickets/' + ticketId).then(function (response) {
                if (response.status === 200) {
                    commit('setTicket', response.data)
                    return
                }
                commit('setTicket', false)
            }).catch((error) => {
                commit('setTicket', false)
            })
        },
        async downloadTypes({state, commit, rootGetters}) {
            commit('resetTypes')
            await axios.get('/companies/' + rootGetters.companyId + '/types/').then(function (response) {
                if (response.status === 200) {
                    commit('setTypes', response.data)
                }
            }).catch((error) => {})
        }
    }
}